import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import FactorDivision from './FactorDivision/FactorDivision'
import FactorNegative from './FactorNegative/FactorNegative'
import FactorSelect from './FactorSelect/FactorSelect'
import FactorTree from './FactorTree/FactorTree'
import PrimeSelect from './PrimeSelect/PrimeSelect'

enum Bootcamp1ActivitieTypes {
  primeSelect = 'PrimeSelect',
  factorSelect = 'FactorSelect',
  factorTree = 'FactorTree',
  factorDivision = 'FactorDivision',
  factorNegative = 'FactorNegative',
}

const Bootcamp1Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case Bootcamp1ActivitieTypes.primeSelect:
      return <PrimeSelect {...props} />
    case Bootcamp1ActivitieTypes.factorSelect:
      return <FactorSelect {...props} />
    case Bootcamp1ActivitieTypes.factorTree:
      return <FactorTree {...props} />
    case Bootcamp1ActivitieTypes.factorDivision:
      return <FactorDivision {...props} />
    case Bootcamp1ActivitieTypes.factorNegative:
      return <FactorNegative {...props} />
    default:
      return <></>
  }
}

export default Bootcamp1Activities
